import { render, staticRenderFns } from "./CadastroTerceiroProcedimentos.vue?vue&type=template&id=d7e7c3ba&scoped=true&"
import script from "./CadastroTerceiroProcedimentos.vue?vue&type=script&lang=js&"
export * from "./CadastroTerceiroProcedimentos.vue?vue&type=script&lang=js&"
import style0 from "./CadastroTerceiroProcedimentos.vue?vue&type=style&index=0&id=d7e7c3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e7c3ba",
  null
  
)

export default component.exports